import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const KsDLCoAService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getSubmissionsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/kdor/search${queryString}`, {
      headers,
    });
  };

  service.getSubmissionsBySearchCriteria = getSubmissionsBySearchCriteria;

  return service;
})();

export default KsDLCoAService;
